import ajax from "../assets/uilt/ajax";

const operatingPayment = {
  commissionBalances: (req) =>
    ajax.get({
      url: "/back/operating-payment/commission-balances",
      param: req.param,
      success: req.success,
      failing: req.failing,
    }),

  findCustomer: (req) =>
    ajax.get({
      url: "/back/operating-payment/find-customer",
      param: req.param,
      success: req.success,
      failing: req.failing,
    }),

  add: (req) =>
    ajax.post({
      url: "/back/operating-payment/add",
      param: req.param,
      success: req.success,
      failing: req.failing,
    }),

  approve: (req) =>
    ajax.post({
      url: "/back/operating-payment/approve",
      param: req.param,
      success: req.success,
      failing: req.failing,
    }),

  reject: (req) =>
    ajax.post({
      url: "/back/operating-payment/reject",
      param: req.param,
      success: req.success,
      failing: req.failing,
    }),

  page: (req) =>
    ajax.get({
      url: "/back/operating-payment/page",
      param: req.param,
      success: req.success,
      failing: req.failing,
    }),

  detail: (req) =>
    ajax.get({
      url: "/back/operating-payment/detail",
      param: req.param,
      success: req.success,
      failing: req.failing,
    }),
};

export default operatingPayment;
